import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Shell } from "@/components/Shell";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 8) return setError("Password must be at least 8 characters.");
    if (form.password !== form.confirm) return setError("Passwords do not match.");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: form.password });
      signIn(data);
      toast.success("Password updated — you're logged in.");
      nav(data.user.role === "admin" ? "/admin" : "/play");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Shell hideNav>
      <div className="fade-up">
        <p className="eyebrow">Account recovery</p>
        <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight">Set a new password</h1>
        {!token ? (
          <div className="panel mt-8 p-5" data-testid="reset-missing-token">
            <p className="text-sm text-slate-200">This reset link is incomplete.</p>
            <Link to="/forgot-password" className="btn-secondary mt-5 w-full" data-testid="reset-request-new-link">Request a new link</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-form">
            <label className="block">
              <span className="eyebrow mb-2 block">New password</span>
              <input className="field" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="At least 8 characters" required minLength={8} autoComplete="new-password" data-testid="reset-password-input" />
            </label>
            <label className="block">
              <span className="eyebrow mb-2 block">Confirm new password</span>
              <input className="field" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required autoComplete="new-password" data-testid="reset-confirm-input" />
            </label>
            {error && <p className="rounded-xl border border-rose-500/40 bg-rose-500/10 px-4 py-3 text-sm text-rose-300" data-testid="reset-error">{error}</p>}
            <button className="btn-primary w-full" disabled={busy} data-testid="reset-submit-button">{busy ? "Saving…" : "Save new password"}</button>
            <p className="text-center text-sm text-slate-400">Link expired? <Link to="/forgot-password" className="font-semibold text-white underline-offset-4 hover:underline" data-testid="reset-forgot-link">Request a new one</Link></p>
          </form>
        )}
      </div>
    </Shell>
  );
}
